// src/icons/svgs/swap.svg
import * as React from "react";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var SvgSwap = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 20, height: 20, fill: "none", viewBox: "0 0 20 20", ref, ...props, children: /* @__PURE__ */ jsx("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", d: "m15 1.833 3.333 3.334L15 8.5M3.799 5.008h14M5.416 18.167l-3.333-3.334L5.416 11.5M2.799 14.675h14" }) });
var ForwardRef = forwardRef(SvgSwap);
var swap_default = ForwardRef;
export {
  swap_default as Swap
};
